module.exports = __webpack_public_path__ + "static/media/mobile.acc840ad.svg";